module.exports = __webpack_public_path__ + "img/mbBanner15.255c15c5.png";